export const departments = [
    {
      "id": 10,
      "name": "AUDIO",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 20,
      "name": "SMART HOME",
      "Timestamp": "2019-07-17T14:35:59.4275528+00:00"
    },
    {
      "id": 30,
      "name": "VISUAL",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 35,
      "name": "FITNESS",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 50,
      "name": "IN CAR",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 55,
      "name": "SMALL APPLIANCES",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 62,
      "name": "ACCESSORIES",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 65,
      "name": "IT",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 70,
      "name": "CAMERAS",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 75,
      "name": "COMPUTERS",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 80,
      "name": "COMMUNICATIONS",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 85,
      "name": "WHITEGOODS",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 90,
      "name": "GAMES HARDWARE",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 92,
      "name": "GAMES SOFTWARE",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 100,
      "name": "MUSIC",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 110,
      "name": "MOVIES",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 120,
      "name": "SERVICES",
      "Timestamp": "2020-08-04T15:52:52.193+10:00"
    },
    {
      "id": 121,
      "name": "GIFT VOUCHERS",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 130,
      "name": "MISCELLANEOUS",
      "Timestamp": "2021-10-14T17:28:51.8+11:00"
    },
    {
      "id": 300,
      "name": "PROFESSIONAL SERVICES",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    },
    {
      "id": 301,
      "name": "B2B TELCO INCENTIVES",
      "Timestamp": "2017-12-01T01:50:07.2108216+00:00"
    }
  ]

  export const productGroups = [
    {
      "id": 1,
      "name": "BIGPOND 50% OFF",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2,
      "name": "XTREMEMAC BOGOF",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 3,
      "name": "SONY HEADPHONES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 4,
      "name": "SIMPLISM IPHONE BOGOF",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 5,
      "name": "IT - CRICUT HARDWARE",
      "Timestamp": "2021-09-13T17:32:08.8+10:00"
    },
    {
      "id": 6,
      "name": "IT - LAPTOP CHARGERS/ADAPTERS",
      "Timestamp": "2020-10-15T21:03:19.427+11:00"
    },
    {
      "id": 7,
      "name": "HDD PORTABLE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 8,
      "name": "HDD PORTABLE WIRELESS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 9,
      "name": "HDD DESKTOP CLOUD",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 10,
      "name": "IT - MICROSOFT SURFACE ACCESSORIES",
      "Timestamp": "2020-07-01T15:54:57.577+10:00"
    },
    {
      "id": 11,
      "name": "IT - MICROSOFT 365 POSA/ESD",
      "Timestamp": "2020-04-23T15:54:57.193+10:00"
    },
    {
      "id": 12,
      "name": "OPTICAL DRIVE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 13,
      "name": "SSD EXTERNAL",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 14,
      "name": "IT - CRICUT ACCESSORIES/CONSUMABLES",
      "Timestamp": "2021-09-13T17:32:08.8+10:00"
    },
    {
      "id": 15,
      "name": "IT - GRAPHICS TABLETS",
      "Timestamp": "2021-08-19T17:32:08.87+10:00"
    },
    {
      "id": 16,
      "name": "CASES/SCREEN PROTECTION",
      "Timestamp": "2018-05-01T23:28:59.9449308+00:00"
    },
    {
      "id": 101,
      "name": "SYSTEMS MINI",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 102,
      "name": "SYSTEMS MIDI",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 103,
      "name": "SYSTEMS MICRO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 104,
      "name": "CD PLAYERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 105,
      "name": "RECEIVERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 106,
      "name": "AMPS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 107,
      "name": "TAPE DECK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 108,
      "name": "EQUALISERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 109,
      "name": "TURNTABLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 110,
      "name": "HI FI CABINETS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 111,
      "name": "Hi Fi Open Sales",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 112,
      "name": "MINIDISC HIFI",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 113,
      "name": "LIFESTYLE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 115,
      "name": "HOME THEATRE IN A BOX",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 116,
      "name": "COMPONENT SYSTEMS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 117,
      "name": "WIRELESS ACCESS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 118,
      "name": "IPOD DOCKING MICRO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 119,
      "name": "RECEIVER DOCKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 120,
      "name": "BLURAY LIFESTYLE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 121,
      "name": "KITCHEN SKILLET",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 122,
      "name": "KITCHEN HAND MIXER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 123,
      "name": "SOUNDBAR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 124,
      "name": "HEADPHONES - TRUE WIRELESS",
      "Timestamp": "2019-08-08T04:53:36.3984373+00:00"
    },
    {
      "id": 125,
      "name": "SOUNDBARS - BULKY",
      "Timestamp": "2021-02-12T11:36:06.59+11:00"
    },
    {
      "id": 130,
      "name": "CD DIGITAL RADIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 131,
      "name": "DIGITAL RADIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 140,
      "name": "WORK FROM HOME - AUDIO",
      "Timestamp": "2022-06-14T12:50:12.313+10:00"
    },
    {
      "id": 141,
      "name": "DO NOT USE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 142,
      "name": "DO NOT USE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 149,
      "name": "MI UKULELE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 151,
      "name": "MI PORTABLE KEYBOARD",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 152,
      "name": "MI DIGITAL PIANO",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 153,
      "name": "DO NOT USE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 154,
      "name": "MI SYNTHESIZER",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 155,
      "name": "MI KEYBOARD ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 156,
      "name": "MI ELECTRIC GUITAR",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 157,
      "name": "MI ACOUSTIC GUITAR",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 158,
      "name": "MI GUITAR ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 159,
      "name": "MI GUITAR AMPLIFIER",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 160,
      "name": "MI DRUM KIT",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 161,
      "name": "MI BASS GUITAR",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 167,
      "name": "MI GUITAR PEDAL",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 168,
      "name": "MI DRUM ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 169,
      "name": "MUSICAL INSTRUMENTS - OTHER",
      "Timestamp": "2019-12-17T06:33:41.27+11:00"
    },
    {
      "id": 170,
      "name": "MI WOODWIND INSTRUMENT",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 171,
      "name": "MI WOODWIND ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 172,
      "name": "MI BRASS INSTRUMENT",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 173,
      "name": "MI BRASS ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 174,
      "name": "MI STRING INSTRUMENT",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 175,
      "name": "MI STRING ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 176,
      "name": "MI PRINT",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 177,
      "name": "DO NOT USE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 178,
      "name": "DO NOT USE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 179,
      "name": "MI PERCUSSION ORCHESTRAL",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 180,
      "name": "MI DJ CONTROLLER",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 181,
      "name": "MI DJ MIXER",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 182,
      "name": "MI DJ TURNTABLE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 183,
      "name": "MI DJ LIGHT",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 184,
      "name": "MI PRO ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 185,
      "name": "MI PRO HEADPHONE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 186,
      "name": "MI PRO AUDIO INTERFACE",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 188,
      "name": "MI MICROPHONE USB",
      "Timestamp": "2021-12-08T02:16:09.827+11:00"
    },
    {
      "id": 190,
      "name": "MI PRO MIXER",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 191,
      "name": "MI PRO PA",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 192,
      "name": "MI PRO STUDIO MONITOR",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 193,
      "name": "MI PRO MICS",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 194,
      "name": "MI PERCUSSION OTHER",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 195,
      "name": "MI PERCUSSION ACCESSORY",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 196,
      "name": "MI ACOUSTIC PIANO",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 197,
      "name": "MI PRO MIDI CONTROLLER",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 198,
      "name": "MI PRO",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 199,
      "name": "MI ACOUSTIC TREATMENT",
      "Timestamp": "2019-09-24T06:46:57.1059943+00:00"
    },
    {
      "id": 201,
      "name": "FLOOR SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 202,
      "name": "BOOKSHELF SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 203,
      "name": "5.1 SYSTEM",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 204,
      "name": "CENTER SPEAKER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 205,
      "name": "SUB WOOFER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 206,
      "name": "SPEAKER STANDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 207,
      "name": "OUTDOOR / INWALL SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 247,
      "name": "FITNESS - HEALTH WELLBEING",
      "Timestamp": "2019-05-16T02:49:56.167419+00:00"
    },
    {
      "id": 248,
      "name": "FITNESS - SCALES",
      "Timestamp": "2019-05-27T01:15:58.302367+00:00"
    },
    {
      "id": 301,
      "name": "PC - SPARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 302,
      "name": "UHD LED TV - 100+",
      "Timestamp": "2021-06-18T22:02:03.343+10:00"
    },
    {
      "id": 303,
      "name": "T5 STOCK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 304,
      "name": "TV -51cm",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 305,
      "name": "2x $30 ITUNES CARDS FOR $40",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 306,
      "name": "TV -66 / 68cm",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 307,
      "name": "PDP INTEGRATED - 32+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 308,
      "name": "TV -PLASMA",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 309,
      "name": "BLU-RAY HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 310,
      "name": "TV -LCD PROJECTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 311,
      "name": "VCR HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 312,
      "name": "DVD HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 313,
      "name": "TV - CABINETS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 314,
      "name": "TV / VIDEO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 315,
      "name": "TV - WIDE SCREEN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 316,
      "name": "PROJECTOR SCREENS",
      "Timestamp": "2020-11-18T11:36:07.68+11:00"
    },
    {
      "id": 317,
      "name": "SET TOP BOXES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 318,
      "name": "VISUAL ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 319,
      "name": "TV - LCD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 320,
      "name": "TV - REAR PRO WIDE SCREEN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 321,
      "name": "PORTABLE DVD HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 322,
      "name": "DVD RECORDER HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 323,
      "name": "LED TV - ALL SIZES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 324,
      "name": "LCD TV - 15+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 325,
      "name": "LCD TV - 26+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 326,
      "name": "LCD TV - 32+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 327,
      "name": "LCD TV - 40+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 328,
      "name": "PVR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 329,
      "name": "June 2009 - PS3 Bravia Deal",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 334,
      "name": "LED TV - 15+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 335,
      "name": "LED TV - 26+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 336,
      "name": "LED TV - 32+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 337,
      "name": "FHD LED TV - 40+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 338,
      "name": "OLED TV - 46+",
      "Timestamp": "2021-03-05T13:17:49.25+11:00"
    },
    {
      "id": 339,
      "name": "FHD LED TV - 42+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 340,
      "name": "FHD LED TV - 46+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 341,
      "name": "FHD LED TV - 55+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 342,
      "name": "PDP INTEGRATED - 42+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 343,
      "name": "PDP INTEGRATED - 50+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 344,
      "name": "PDP INTEGRATED - 55+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 345,
      "name": "PVR - TELSTRA",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 346,
      "name": "FHD LED TV - 60+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 347,
      "name": "FHD LED TV - 70+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 348,
      "name": "FHD LED TV - 80+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 349,
      "name": "NAVIGATION - HANDHELD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 350,
      "name": "NAVIGATION - 4.3\" SCREEN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 351,
      "name": "NAVIGATION - 3.5\" SCREEN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 352,
      "name": "NAVIGATION - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 353,
      "name": "NAVIGATION - DASH CAM",
      "Timestamp": "2018-07-12T08:10:35.9080973+00:00"
    },
    {
      "id": 354,
      "name": "NAVIGATION - 5.0\" AND ABOVE SCREEN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 355,
      "name": "FITNESS - SPORTS WATCH",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 356,
      "name": "FITNESS - ACTIVITY TRACKER",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 357,
      "name": "FITNESS - SMARTWATCH",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 358,
      "name": "FITNESS - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 359,
      "name": "OLED TV - 80+",
      "Timestamp": "2021-04-12T22:10:27.007+10:00"
    },
    {
      "id": 360,
      "name": "FITNESS - MASSAGE THERAPY",
      "Timestamp": "2019-09-04T06:46:57.2294325+00:00"
    },
    {
      "id": 361,
      "name": "UHD LED TV - 40+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 362,
      "name": "UHD LED TV - 46+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 363,
      "name": "UHD LED TV - 55+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 364,
      "name": "UHD LED TV - 60+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 365,
      "name": "UHD LED TV - 65+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 366,
      "name": "UHD LED TV - 70+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 367,
      "name": "UHD LED TV - 80+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 368,
      "name": "OLED TV - 55+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 369,
      "name": "OLED TV - 65+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 370,
      "name": "OLED TV - 70+",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 371,
      "name": "FITNESS - CYCLING",
      "Timestamp": "2021-05-26T13:49:02.75+10:00"
    },
    {
      "id": 372,
      "name": "8K LED TV 55+",
      "Timestamp": "2020-04-16T15:54:57.62+10:00"
    },
    {
      "id": 373,
      "name": "8K LED TV 65+",
      "Timestamp": "2020-04-16T15:54:57.62+10:00"
    },
    {
      "id": 374,
      "name": "8K LED TV 70+",
      "Timestamp": "2020-06-17T15:54:57.77+10:00"
    },
    {
      "id": 375,
      "name": "8K LED TV 80+",
      "Timestamp": "2020-04-16T15:54:57.62+10:00"
    },
    {
      "id": 376,
      "name": "HOME ENTERTAINMENT PROJECTORS",
      "Timestamp": "2020-10-14T21:03:18.797+11:00"
    },
    {
      "id": 377,
      "name": "FITNESS - WATCH BAND ACCESSORIES",
      "Timestamp": "2021-02-16T11:36:06.683+11:00"
    },
    {
      "id": 378,
      "name": "FITNESS - CHARGING CABLES",
      "Timestamp": "2021-02-16T11:36:06.683+11:00"
    },
    {
      "id": 379,
      "name": "FITNESS - SCREEN PROTECTORS",
      "Timestamp": "2021-02-16T11:36:06.683+11:00"
    },
    {
      "id": 401,
      "name": "RADIO CASSETTE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 402,
      "name": "CD RADIO CASSETTE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 403,
      "name": "WALKMAN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 404,
      "name": "DISCMAN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 405,
      "name": "MINIDISC - PORTABLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 406,
      "name": "CLOCK RADIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 407,
      "name": "MP3 FLASH",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 408,
      "name": "PORTABLE OTHER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 409,
      "name": "COMPUTER SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 410,
      "name": "MP3 ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 411,
      "name": "MP3 HDD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 412,
      "name": "MP4",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 413,
      "name": "iTUNES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 414,
      "name": "DIGITAL HOME NETWORKING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 415,
      "name": "IPOD FLASH",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 416,
      "name": "IPOD HDD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 417,
      "name": "IPOD SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 420,
      "name": "MUSIC VOUCHERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 421,
      "name": "COOK TOPS - ELECTRIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 422,
      "name": "COOK TOPS - GAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 423,
      "name": "COOK TOPS - DUEL FUEL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 424,
      "name": "COOK TOPS - INDUCTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 425,
      "name": "OVENS - ELECTRIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 426,
      "name": "OVENS - GAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 427,
      "name": "OVENS - DUEL FUEL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 428,
      "name": "MICROWAVE - BUILT IN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 429,
      "name": "PACK - OVEN/COOK TOP PACK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 430,
      "name": "PACK - OVEN/COOK TOP/HOOD PACK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 431,
      "name": "RANGES - ELECTRIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 432,
      "name": "RANGES - GAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 433,
      "name": "RANGES - DUEL FUEL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 434,
      "name": "HOODS/CANOPIES - FIXED & UNDERMOUNT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 435,
      "name": "HOODS/CANOPIES - SLIDE OUT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 436,
      "name": "HOODS/CANOPIES - CANOPY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 437,
      "name": "HOODS/CANOPIES - DOWNDRAFT EXT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 438,
      "name": "HOODS/CANOPIES - SPLASH BACK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 439,
      "name": "ACCESSORIES - COOKING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 440,
      "name": "ACCESSORIES - RANGE HOOD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 441,
      "name": "ACCESSORIES - SINK & TAP ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 442,
      "name": "SINKS & WASTE - SINKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 443,
      "name": "SINKS & WASTE - TAPS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 444,
      "name": "SINKS & WASTE - SINK & TAPS PACKAGE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 445,
      "name": "SINKS & WASTE - WASTE DISPOSERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 446,
      "name": "SINKS & WASTE - WASTE COMPACTORS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 447,
      "name": "WATER - ELECTRIC HWS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 448,
      "name": "WATER - SOLAR HWS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 449,
      "name": "WATER - GAS HWS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 450,
      "name": "SINKS & WASTE - BATHROOM",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 451,
      "name": "WATER - FILTRATION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 452,
      "name": "SMALLS SPARE 2",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 453,
      "name": "BBQ ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 454,
      "name": "OVENS -  BI STEAM/ MICROWAVE/ COMBI",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 455,
      "name": "OVENS - PYROLYTIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 456,
      "name": "BUILT IN COFFEE MACHINE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 461,
      "name": "AIRCON BOX - COOL ONLY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 462,
      "name": "AIRCON BOX - REVERSE CYCLE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 463,
      "name": "AIRCON SPLIT - COOL ONLY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 464,
      "name": "AIRCON SPLIT - REVERSE CYCLE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 465,
      "name": "AIRCON CASSETTE - COOL ONLY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 466,
      "name": "AIRCON CASSETTE - REVERSE CYCLE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 467,
      "name": "AIRCON DUCTED - UNITS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 468,
      "name": "AIRCON DUCTED ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 469,
      "name": "MOBILE - AIRCON",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 470,
      "name": "MOBILE - EVAPORATIVE COOLER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 471,
      "name": "MOBILE - DEHUMIDIFIER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 472,
      "name": "FANS - BOX / PEDESTAL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 473,
      "name": "FANS - CEILINGS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 474,
      "name": "FANS - EXHAUST",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 475,
      "name": "HEATERS - ELECTRIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 476,
      "name": "HEATERS - GAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 477,
      "name": "HEATERS - TOWEL RAILS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 478,
      "name": "HEATERS - ELECTRIC BLANKETS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 479,
      "name": "HEATERS - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 480,
      "name": "DUCTED DELIVERY / INSTALL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 481,
      "name": "AIR CURTAINS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 482,
      "name": "KITCHEN - COFFEE CAPSULES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 483,
      "name": "FANS - AIR PURIFIERS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 499,
      "name": "HOUSEHOLD - GARMENT STEAMERS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 500,
      "name": "CLEANING - VACS ROBOTIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 501,
      "name": "CAR RADIO CASSETTE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 502,
      "name": "CAR CD TUNER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 503,
      "name": "CAR MD TUNER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 504,
      "name": "CAR CD STACKER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 505,
      "name": "CAR AMPS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 506,
      "name": "CAR ALARMS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 507,
      "name": "CAR NAVIGATIONAL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 508,
      "name": "CAR TV MONITOR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 509,
      "name": "CAR SOUND ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 510,
      "name": "CAR SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 511,
      "name": "CAR DOOR LOCKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 512,
      "name": "IN-CAR ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 513,
      "name": "CAR BLUETOOTH",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 514,
      "name": "CAR SUBS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 515,
      "name": "CAR MP3 PLAYER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 516,
      "name": "CAR SUB BOXES (EMPTY)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 517,
      "name": "CAR SUB PREFAB",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 518,
      "name": "CAR NEONS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 519,
      "name": "CAR ANTENNAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 520,
      "name": "CAR KITS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 521,
      "name": "CAR CABLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 522,
      "name": "CAR RCA LEADS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 523,
      "name": "CAR TERMINALS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 524,
      "name": "CAR DVD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 525,
      "name": "CAR COMBO PACKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 526,
      "name": "CAR CAMERA",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 527,
      "name": "KITCHEN - COFFEE NESPRESSO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 528,
      "name": "KITCHEN - COFFEE MANUAL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 529,
      "name": "KITCHEN - COFFEE FULLY AUTO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 530,
      "name": "FANS - DEHUMIDIFIER",
      "Timestamp": "2022-05-04T12:50:12.383+10:00"
    },
    {
      "id": 531,
      "name": "CAR - FACIA/DASH KITS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 532,
      "name": "PERSONAL CARE - HAIR DRYERS",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 533,
      "name": "PERSONAL CARE HAIRSTYLERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 534,
      "name": "PERSONAL CARE - HAIR STRAIGHTENER",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 535,
      "name": "PERSONAL CARE - WOMENS HAIR REMOVAL",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 536,
      "name": "PERSONAL CARE - SHAVER ACCESSORIES",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 537,
      "name": "PERSONAL CARE MIRRORS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 538,
      "name": "PERSONAL CARE FOOT SPAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 539,
      "name": "PERSONAL CARE SCALES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 540,
      "name": "PERSONAL CARE - TOOTHBRUSH ACCESSORIES",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 541,
      "name": "KITCHEN - POTS & PANS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 542,
      "name": "KITCHEN - BREAD MAKER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 543,
      "name": "KITCHEN - TOASTER 4 SLICE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 544,
      "name": "KITCHEN - TOASTER 2 SLICE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 545,
      "name": "KITCHEN - KETTLES",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 546,
      "name": "KITCHEN - KETTLES WHITE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 547,
      "name": "KITCHEN - KETTLES STAINLESS STEEL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 548,
      "name": "KITCHEN - URNS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 549,
      "name": "KITCHEN - MIXER ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 550,
      "name": "KITCHEN - BEVERAGE MAKER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 551,
      "name": "KITCHEN - PORTABLE OVEN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 552,
      "name": "KITCHEN - GRILLS / SNACK MAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 553,
      "name": "KITCHEN - MULTI / PRESSURE COOKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 554,
      "name": "KITCHEN - ELECTRIC FRYING PANS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 555,
      "name": "KITCHEN - COFFEE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 556,
      "name": "KITCHEN - VAC SEALERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 557,
      "name": "KITCHEN - FOOD PREPARATION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 558,
      "name": "PERSONAL CARE - TOOTHBRUSHES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 559,
      "name": "PERSONAL CARE - SHAVERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 560,
      "name": "PERSONAL CARE - HAIR CARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 561,
      "name": "PERSONAL CARE - THERAPEUTIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 562,
      "name": "CLEANING - VACS BARREL / CANISTER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 563,
      "name": "CLEANING - VACS WET / DRY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 564,
      "name": "CLEANING - VACS UPRIGHTS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 565,
      "name": "CLEANING - VACS HAND HELD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 566,
      "name": "CLEANING - VACS ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 567,
      "name": "CLEANING - VACS BAGS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 568,
      "name": "CLEANING - STEAM CLEANERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 569,
      "name": "HOUSEHOLD - IRONS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 570,
      "name": "HOUSEHOLD - IRONING CENTERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 571,
      "name": "KITCHEN - BEVERAGE MAKER ACCESSORIES",
      "Timestamp": "2022-03-11T12:50:12.233+11:00"
    },
    {
      "id": 572,
      "name": "CLEANING - VACS BARREL BAGLESS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 573,
      "name": "CLEANING - VACS UPRIGHTS BAGLESS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 574,
      "name": "KITCHEN - PACKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 575,
      "name": "KITCHEN - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 576,
      "name": "KITCHEN - BLENDERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 577,
      "name": "KITCHEN - JUICERS / PRESSES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 578,
      "name": "PERSONAL CARE - HAIR REMOVAL / GROOMING",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 579,
      "name": "CLEANING - STEAM MOP",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 580,
      "name": "CLEANING - STEAM ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 581,
      "name": "CLEANING - STICK VAC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 582,
      "name": "HOUSEHOLD - STEAM STATION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 583,
      "name": "HOUSEHOLD - IRON BOARDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 584,
      "name": "KITCHEN - SCALES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 585,
      "name": "HOUSEHOLD - IRON ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 586,
      "name": "KITCHEN - FOOD PROCESSOR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 587,
      "name": "KITCHEN - NOVELTY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 588,
      "name": "KITCHEN - COFFEE ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 589,
      "name": "KITCHEN - HOTPLATES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 590,
      "name": "KITCHEN - KNIFE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 591,
      "name": "KITCHEN - WATER FILTER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 592,
      "name": "KITCHEN - STICKMIXER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 593,
      "name": "KITCHEN - SLOWCOOKER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 594,
      "name": "KITCHEN - STEAMER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 595,
      "name": "KITCHEN - AIR FRYER",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 596,
      "name": "KITCHEN - RICECOOKER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 597,
      "name": "KITCHEN - WOK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 598,
      "name": "KITCHEN - SKILLET",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 599,
      "name": "KITCHEN - HAND MIXER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 600,
      "name": "KITCHEN - MIXER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 601,
      "name": "TAPE - AUDIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 602,
      "name": "TAPE - VIDEO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 603,
      "name": "IT - BLANK MEDIA",
      "Timestamp": "2020-07-09T15:54:57.587+10:00"
    },
    {
      "id": 604,
      "name": "EREADER ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 605,
      "name": "PORTABLE TRAVEL SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 606,
      "name": "BATTERIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 607,
      "name": "HEADPHONES - OVER-EAR WIRED",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 608,
      "name": "AV CABLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 609,
      "name": "ACCESSORIES - OTHER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 610,
      "name": "CLEANING",
      "Timestamp": "2022-05-02T12:50:12.427+10:00"
    },
    {
      "id": 611,
      "name": "DVD-R",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 612,
      "name": "CAMERA MEDIA",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 613,
      "name": "REMOTE CONTROLS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 614,
      "name": "USB STORAGE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 615,
      "name": "PRO DJ ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 616,
      "name": "AV BRACKETS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 617,
      "name": "CONNECTIVITY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 618,
      "name": "HOME OFFICE FURNITURE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 619,
      "name": "PERSONAL STORAGE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 620,
      "name": "MEDIA CASE STORAGE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 621,
      "name": "AV SURGE PROTECTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 622,
      "name": "IT - CABLES",
      "Timestamp": "2018-08-22T14:28:47.4718369+00:00"
    },
    {
      "id": 623,
      "name": "KITCHEN - CHOPPERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 624,
      "name": "IT - SURGE PROTECTION & UPS",
      "Timestamp": "2018-08-22T14:28:47.4718369+00:00"
    },
    {
      "id": 625,
      "name": "PC/GAMING HEADPHONES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 626,
      "name": "LAPTOP BAGS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 627,
      "name": "HOME OFFICE MINI",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 628,
      "name": "MP3 ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 629,
      "name": "CAMERA BAGS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 630,
      "name": "ACCESSORIES - BLUETOOTH",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 631,
      "name": "IT - PC COMPONENTS",
      "Timestamp": "2018-08-22T14:28:47.4718369+00:00"
    },
    {
      "id": 632,
      "name": "PC MISC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 633,
      "name": "CLOCK RADIO DIGITAL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 634,
      "name": "DIGITAL RADIO IPOD DOCK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 635,
      "name": "IPHONE CASES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 636,
      "name": "IPAD CASES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 637,
      "name": "WIRELESS AUDIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 638,
      "name": "TABLET ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 639,
      "name": "(APP)CESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 640,
      "name": "IPOD CASES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 641,
      "name": "SCREENGUARDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 642,
      "name": "SLEEVES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 643,
      "name": "APPLE IPAD COVERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 644,
      "name": "HEADPHONES - IN-EAR WIRED",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 645,
      "name": "IT - LAPTOP & MONITOR STANDS/MOUNTS",
      "Timestamp": "2021-05-10T13:49:02.777+10:00"
    },
    {
      "id": 646,
      "name": "IPAD MINI CASES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 647,
      "name": "FITNESS - KIDS",
      "Timestamp": "2019-05-16T01:49:56.175918+00:00"
    },
    {
      "id": 648,
      "name": "KEYBOARD FOLIOS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 649,
      "name": "YS FUN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 650,
      "name": "MOBILE PORTABLE POWER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 651,
      "name": "MEDIA STREAMING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 652,
      "name": "COMPUTER SOFTWARE - POSA/ESD",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 653,
      "name": "IT - PRINTER HARDWARE",
      "Timestamp": "2019-11-19T05:48:13.5522336+00:00"
    },
    {
      "id": 654,
      "name": "IT - USB-C ADAPTERS & HUBS",
      "Timestamp": "2022-06-16T12:50:12.373+10:00"
    },
    {
      "id": 655,
      "name": "IT - KEYBOARDS & COMBOS",
      "Timestamp": "2022-05-02T12:50:12.427+10:00"
    },
    {
      "id": 656,
      "name": "WEBCAMS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 657,
      "name": "HDD DESKTOP",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 658,
      "name": "Mac ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 659,
      "name": "IT - USB-A ACCESSORIES",
      "Timestamp": "2022-06-17T12:50:12.203+10:00"
    },
    {
      "id": 660,
      "name": "IT - MOUSE PADS/ERGO ACCESSORIES",
      "Timestamp": "2021-12-08T02:16:09.827+11:00"
    },
    {
      "id": 661,
      "name": "LASER PRINTERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 662,
      "name": "DIGITAL PHOTO FRAMES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 663,
      "name": "SMART HOME - SECURITY",
      "Timestamp": "2019-07-18T02:53:36.3971947+00:00"
    },
    {
      "id": 664,
      "name": "MICE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 665,
      "name": "ACCESSORY CONNECTORS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 666,
      "name": "FM TRANSMITTERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 667,
      "name": "MOBILE MOUNTS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 668,
      "name": "STYLUS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 669,
      "name": "SYNC CABLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 670,
      "name": "AV ANTENNAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 671,
      "name": "LICENCE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 672,
      "name": "MICRO SD CARDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 673,
      "name": "TRAVEL ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 674,
      "name": "SOFT ACC FITNESS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 675,
      "name": "MACBOOK ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 676,
      "name": "IPAD PRO ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 677,
      "name": "AUXILLARY CABLES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 678,
      "name": "MICRO CABLES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 679,
      "name": "USB-C CABLES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 680,
      "name": "FLEA MARKET",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 681,
      "name": "BOARDGAMES PUZZLES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 682,
      "name": "GREETING CARDS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 683,
      "name": "MULTIROOM SPEAKERS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 684,
      "name": "HEADPHONES OVER EAR NOISE CANCEL",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 685,
      "name": "HEADPHONES IN EAR NOISE CANCEL",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 686,
      "name": "HEADPHONES OVER EAR SPORTS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 687,
      "name": "HEADPHONES IN EAR SPORTS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 688,
      "name": "HEADPHONES OVER EAR SPORTS BLUETOOTH",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 689,
      "name": "HEADPHONES IN EAR SPORTS BLUETOOTH",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 690,
      "name": "HEADPHONES OVER EAR WIRELESS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 691,
      "name": "HEADPHONES IN EAR WIRELESS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 692,
      "name": "CHARGERS WIRELESS",
      "Timestamp": "2017-12-21T14:04:08.9687156+00:00"
    },
    {
      "id": 693,
      "name": "VOICE SPEAKERS",
      "Timestamp": "2018-07-24T01:10:35.9054721+00:00"
    },
    {
      "id": 694,
      "name": "AV HDMI CABLES",
      "Timestamp": "2018-08-22T14:28:47.4718369+00:00"
    },
    {
      "id": 695,
      "name": "STEM - PRODUCTS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 696,
      "name": "SLEEP AIDS",
      "Timestamp": "2018-08-22T14:28:47.4718369+00:00"
    },
    {
      "id": 697,
      "name": "SMART HOME - PET TECH",
      "Timestamp": "2019-07-18T02:53:36.3971947+00:00"
    },
    {
      "id": 698,
      "name": "TECH ON WHEELS - RIDEABLES",
      "Timestamp": "2020-06-30T15:54:57.93+10:00"
    },
    {
      "id": 699,
      "name": "AR FRAMES",
      "Timestamp": "2019-05-27T01:15:58.302367+00:00"
    },
    {
      "id": 700,
      "name": "IT - INTERNET SECURITY ATTACH",
      "Timestamp": "2019-11-19T05:48:13.5522336+00:00"
    },
    {
      "id": 701,
      "name": "CAMERAS - VIDEO ACTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 702,
      "name": "CAMERAS - VIDEO DVD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 703,
      "name": "SLR LENS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 704,
      "name": "CAMERAS - DSLR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 705,
      "name": "CAMERAS - DSC EVERYDAY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 706,
      "name": "CAMERAS - VIDEO HDD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 707,
      "name": "CAMERA ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 708,
      "name": "BINOCULARS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 709,
      "name": "CAMERAS TRADE IN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 710,
      "name": "CAMERA ACCESSORIES - BATTERIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 711,
      "name": "SD MEMORY CARDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 712,
      "name": "PHOTO PAPER & ACCESSORIES",
      "Timestamp": "2018-07-09T01:05:28.9850407+00:00"
    },
    {
      "id": 713,
      "name": "PHOTO PRINTERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 714,
      "name": "IT - PRINTER INK/CONSUMABLES",
      "Timestamp": "2019-11-19T05:48:13.5522336+00:00"
    },
    {
      "id": 715,
      "name": "INK - 10% OFF PROMOTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 716,
      "name": "LASER TONER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 717,
      "name": "CAMERAS - VIDEO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 718,
      "name": "CAMERA ACCESSORIES - TRIPODS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 719,
      "name": "CAMERAS - MIRRORLESS",
      "Timestamp": "2018-04-05T08:00:51.0941511+00:00"
    },
    {
      "id": 720,
      "name": "CAMERA ACCESSORIES - ACTION CAM",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 721,
      "name": "CAMERA ACCESSORIES - FILTERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 722,
      "name": "MIRRORLESS LENSES & ACCESSORIES",
      "Timestamp": "2018-04-05T08:00:51.0941511+00:00"
    },
    {
      "id": 723,
      "name": "CAMERAS - DSC ULTRA ZOOM",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 724,
      "name": "CAMERAS - DSC HIGH PERFORMANCE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 725,
      "name": "CAMERAS - DSC TOUGH",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 726,
      "name": "CAMERAS - INSTANT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 727,
      "name": "CAMERA ACCESSORIES - LIGHTING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 728,
      "name": "CAMERA ACCESSORIES - AUDIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 730,
      "name": "CAMERA ACCESSORIES - INSTANT",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 737,
      "name": "Laptops Trade Ins",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 738,
      "name": "FITNESS APPLE WATCH ACCESSORIES",
      "Timestamp": "2020-07-09T15:54:57.587+10:00"
    },
    {
      "id": 739,
      "name": "FITNESS APPLE WATCH",
      "Timestamp": "2020-07-09T15:54:57.587+10:00"
    },
    {
      "id": 740,
      "name": "GOOGLE PLAY CARDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 741,
      "name": "LAPTOPS - DETACHABLE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 742,
      "name": "CHROMEBOOKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 743,
      "name": "Laptops - 2 in 1",
      "Timestamp": "2019-12-17T06:33:41.27+11:00"
    },
    {
      "id": 744,
      "name": "TABLETS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 745,
      "name": "APPLE IMAC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 746,
      "name": "APPLE MACBOOK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 747,
      "name": "DELL BTO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 748,
      "name": "APPLE CTO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 749,
      "name": "SMART HOME - HARDWARE",
      "Timestamp": "2019-07-18T02:53:36.3971947+00:00"
    },
    {
      "id": 750,
      "name": "IPAD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 751,
      "name": "LAPTOPS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 752,
      "name": "DESKTOPS AIO",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 753,
      "name": "MONITORS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 754,
      "name": "eREADER HARDWARE",
      "Timestamp": "2019-12-17T06:33:41.27+11:00"
    },
    {
      "id": 755,
      "name": "COMPUTER OTHER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 756,
      "name": "SCANNERS",
      "Timestamp": "2018-11-12T00:36:00.7486259+00:00"
    },
    {
      "id": 757,
      "name": "COMPUTER SOFTWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 758,
      "name": "PERIPHERALS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 759,
      "name": "NETWORK HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 760,
      "name": "COMPUTER ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 761,
      "name": "COMPUTER HEADSETS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 762,
      "name": "COMPUTER TRAINING & SUPPORT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 763,
      "name": "VOIP",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 764,
      "name": "PDA ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 765,
      "name": "IT - USB-C POWERED DOCKS",
      "Timestamp": "2022-06-16T12:50:12.373+10:00"
    },
    {
      "id": 766,
      "name": "B2B SYSTEMS HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 767,
      "name": "IT - PROJECTORS",
      "Timestamp": "2019-07-17T14:42:20.3008662+00:00"
    },
    {
      "id": 768,
      "name": "B2B TELCO SERVICES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 769,
      "name": "DRONES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 770,
      "name": "IPAD - POSTPAID",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 771,
      "name": "DRONE ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 772,
      "name": "SMART HOME - ROBOTICS",
      "Timestamp": "2019-07-18T02:53:36.3971947+00:00"
    },
    {
      "id": 773,
      "name": "SMART HOME - ROBOTICS ACCESSORIES",
      "Timestamp": "2019-07-18T02:53:36.3971947+00:00"
    },
    {
      "id": 774,
      "name": "CAMERAS - GIMBALS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 775,
      "name": "SMART HOME - LIGHTING",
      "Timestamp": "2019-07-18T02:53:36.3971947+00:00"
    },
    {
      "id": 776,
      "name": "SMART HOME - ACCESSORIES",
      "Timestamp": "2019-07-18T02:53:36.3971947+00:00"
    },
    {
      "id": 777,
      "name": "B2B TELCO INCENTIVES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 778,
      "name": "MOBILITY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 779,
      "name": "FIXED",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 780,
      "name": "COMPLEX DATA",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 781,
      "name": "PARTNER SERVICES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 782,
      "name": "TBS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 783,
      "name": "PLAYSTATION VR",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 784,
      "name": "DESKTOP TOWERS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 785,
      "name": "COMPUTER VR",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 786,
      "name": "LAPTOPS - GAMING",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 787,
      "name": "DESKTOPS - GAMING",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 788,
      "name": "MONITORS - GAMING",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 789,
      "name": "COMMERCIAL NETWORK HARDWARE",
      "Timestamp": "2018-03-16T04:00:51.3742249+00:00"
    },
    {
      "id": 791,
      "name": "PC GAMING - APPAREL",
      "Timestamp": "2019-05-15T17:49:56.3600793+00:00"
    },
    {
      "id": 792,
      "name": "TABLETS - POSTPAID",
      "Timestamp": "2021-11-27T02:16:09.827+11:00"
    },
    {
      "id": 799,
      "name": "CAMERAS - 35MM CAMERA & FILM",
      "Timestamp": "2021-11-11T16:30:34.45+11:00"
    },
    {
      "id": 800,
      "name": "MOBILE - OUTRIGHT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 801,
      "name": "MOBILE - PRE PAID",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 802,
      "name": "MOBILE - POST PAID",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 803,
      "name": "CORDLESS PHONES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 804,
      "name": "ADDITIONAL HANDSETS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 805,
      "name": "MOBILE BROADBAND - PREPAID",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 806,
      "name": "TELEPHONE - OTHER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 807,
      "name": "MOBILE TOP-UPS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 808,
      "name": "PHONE TOP-UPS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 809,
      "name": "MOBILE - POSTPAID DEMO UNITS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 810,
      "name": "UHF RADIO - HANDHELD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 811,
      "name": "PHOTO PROCESSING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 812,
      "name": "FUJI PROCESSING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 813,
      "name": "BRANDED DISCOUNT PROCESSING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 814,
      "name": "JB DISCOUNT PROCESSING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 815,
      "name": "MOBILE - BLUETOOTH",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 816,
      "name": "MOBILE - CASES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 817,
      "name": "MOBILE - BATTERIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 818,
      "name": "CHARGERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 819,
      "name": "MOBILE BROADBAND - BIGPOND",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 820,
      "name": "BIGPOND CONTENT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 821,
      "name": "IPAD SIM STARTER KITS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 822,
      "name": "UHF RADIO - IN CAR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 823,
      "name": "MOBILE - PREPAID STARTER KIT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 824,
      "name": "MOBILE GWP OFFERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 825,
      "name": "APPLE iPHONE - OUTRIGHT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 826,
      "name": "MOBILE BROADBAND - POSTPAID",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 827,
      "name": "MOBILE - BOOST PREPAID SIMCARDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 828,
      "name": "MOBILE - BOOST PREPAID HANDSETS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 829,
      "name": "SAMSUNG MOBILE - OUTRIGHT",
      "Timestamp": "2021-06-11T13:49:02.76+10:00"
    },
    {
      "id": 830,
      "name": "TELCO - OFFERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 831,
      "name": "TELCO LOAN DEVICES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 832,
      "name": "TELCO - COMMERCIAL PRODUCTS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 833,
      "name": "TELCO MISC",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 834,
      "name": "MOBILE TRADE IN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 835,
      "name": "Tablet Trade ins",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 836,
      "name": "TELCO - B2B TELSTRA PLANS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 837,
      "name": "GOOGLE MOBILE - OUTRIGHT",
      "Timestamp": "2018-09-19T14:54:28.2568411+00:00"
    },
    {
      "id": 851,
      "name": "REFRIGERATION - BAR FRIDGE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 852,
      "name": "REFRIGERATION - SINGLE DOOR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 853,
      "name": "REFRIGERATION - TOP MOUNT",
      "Timestamp": "2022-02-17T13:39:31.73+11:00"
    },
    {
      "id": 854,
      "name": "REFRIGERATION - SIDE BY SIDE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 855,
      "name": "REFRIGERATION - FRENCH DOOR DISPENSER",
      "Timestamp": "2022-03-21T12:50:12.27+11:00"
    },
    {
      "id": 856,
      "name": "REFRIGERATION - UPRIGHT FREEZER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 857,
      "name": "REFRIGERATION - CHEST FREEZER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 858,
      "name": "REFRIGERATION - WINE CABINET",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 859,
      "name": "DISHWASHER",
      "Timestamp": "2022-03-18T12:50:12.257+11:00"
    },
    {
      "id": 860,
      "name": "DISHWASHER - DRAWERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 861,
      "name": "LAUNDRY - TOP LOAD WASHERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 862,
      "name": "LAUNDRY - FRONT LOAD WASHER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 863,
      "name": "LAUNDRY - WASHER/DRYER PACK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 864,
      "name": "LAUNDRY - TWIN TUB WASHER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 865,
      "name": "LAUNDRY - DRYER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 866,
      "name": "MICROWAVES - NON CONVECTION",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 867,
      "name": "MICROWAVES - CONVECTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 868,
      "name": "ACCESSORIES - LAUNDRY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 869,
      "name": "FANS - HUMIDIFIER",
      "Timestamp": "2022-05-04T12:50:12.383+10:00"
    },
    {
      "id": 870,
      "name": "ACCESSORIES - CLEANERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 871,
      "name": "ACCESSORIES - OTHERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 872,
      "name": "LAUNDRY - DRYER HEAT PUMP",
      "Timestamp": "2022-03-21T12:50:12.27+11:00"
    },
    {
      "id": 873,
      "name": "DISHWASHERS SLIME LINE - BENCHTOP",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 874,
      "name": "REFRIGERATION - BOTTOM MOUNT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 875,
      "name": "REFRIGERATION - FRENCH DOOR",
      "Timestamp": "2022-03-09T12:50:12.453+11:00"
    },
    {
      "id": 900,
      "name": "INCOMM CARDS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 901,
      "name": "GAMES CASES/SCREEN PROTECTION",
      "Timestamp": "2018-07-18T00:10:35.969379+00:00"
    },
    {
      "id": 902,
      "name": "NINTENDO CARDS",
      "Timestamp": "2020-01-10T07:01:42.113+11:00"
    },
    {
      "id": 903,
      "name": "WII U - HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 904,
      "name": "XBOX SERIES CONSOLES",
      "Timestamp": "2020-09-14T09:03:38.5+10:00"
    },
    {
      "id": 905,
      "name": "CHARGING/CABLES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 906,
      "name": "WII U - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 907,
      "name": "MISC GAMING ACCESSORIES",
      "Timestamp": "2020-07-17T15:54:57.793+10:00"
    },
    {
      "id": 908,
      "name": "GAMES MISCELLANEOUS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 909,
      "name": "PSV SOFTWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 910,
      "name": "XBOX GAMES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 911,
      "name": "GAMES TOKENS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 912,
      "name": "Wii BUNDLE EXCLUSIVES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 913,
      "name": "XBOX CONTROLLERS",
      "Timestamp": "2020-07-17T15:54:57.793+10:00"
    },
    {
      "id": 914,
      "name": "WII U - ACTION / ADVENTURE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 915,
      "name": "PS5 CONSOLES",
      "Timestamp": "2019-12-13T05:31:40.1075669+00:00"
    },
    {
      "id": 916,
      "name": "HEADSETS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 917,
      "name": "PS5 ACCESSORIES",
      "Timestamp": "2020-07-17T15:54:57.793+10:00"
    },
    {
      "id": 918,
      "name": "GAMES MERCH/LOOT",
      "Timestamp": "2018-11-12T02:36:00.6496535+00:00"
    },
    {
      "id": 919,
      "name": "KINECT",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 920,
      "name": "GAMES 2 FOR $30",
      "Timestamp": "2021-05-11T13:49:02.87+10:00"
    },
    {
      "id": 921,
      "name": "PC BUY 2 GET 1 FREE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 922,
      "name": "NDS BUNDLE EXCLUSIVES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 923,
      "name": "PSV ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 924,
      "name": "NINTENDO LABO",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 925,
      "name": "NS GAMES - SOFTWARE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 926,
      "name": "GAMES - 2 FOR $40",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 927,
      "name": "PSV HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 928,
      "name": "GAMING MICE",
      "Timestamp": "2019-07-17T14:42:20.3008662+00:00"
    },
    {
      "id": 929,
      "name": "NINTENDO HANDHELD CONSOLES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 930,
      "name": "NDS SOFTWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 931,
      "name": "PS4 CONSOLES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 932,
      "name": "PS4 - DRIVING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 933,
      "name": "PS4 CONTROLLERS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 934,
      "name": "XBONE - ACTION / ADVENTURE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 935,
      "name": "XBOX ONE CONSOLES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 936,
      "name": "NINTENDO SWITCH CONSOLES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 937,
      "name": "NDS ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 938,
      "name": "NINTENDO AMIIBO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 939,
      "name": "NINTENDO SWITCH CONTROLLERS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 940,
      "name": "PS5 CONTROLLERS",
      "Timestamp": "2020-07-17T15:54:57.793+10:00"
    },
    {
      "id": 941,
      "name": "MOBILE GAMING",
      "Timestamp": "2020-01-02T07:01:41.703+11:00"
    },
    {
      "id": 942,
      "name": "PC GAMES - BUDGET",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 943,
      "name": "PC SOFTWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 944,
      "name": "XBOX ACCESSORIES",
      "Timestamp": "2020-07-17T15:54:57.793+10:00"
    },
    {
      "id": 945,
      "name": "$39 SWITCH BUNDLE GAME",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 946,
      "name": "GAMES - 2 FOR FREE DEAL INCLUSIONS",
      "Timestamp": "2018-07-09T01:05:28.9850407+00:00"
    },
    {
      "id": 947,
      "name": "PS4 - FAMILY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 948,
      "name": "PS4 - SHOOTER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 949,
      "name": "PS4 - ACTION / ADVENTURE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 950,
      "name": "PSP SOFTWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 951,
      "name": "PS4 - SPORT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 952,
      "name": "BULKY RETRO",
      "Timestamp": "2022-04-12T12:50:12.32+10:00"
    },
    {
      "id": 953,
      "name": "OLD GEN CONTROLLERS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 954,
      "name": "GAMES PROMOTIONAL",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 955,
      "name": "3DS - HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 956,
      "name": "XBOX ONE - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 957,
      "name": "UMD MUSIC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 958,
      "name": "PC ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 959,
      "name": "GAMING SIMULATION",
      "Timestamp": "2019-05-15T17:49:56.3600793+00:00"
    },
    {
      "id": 960,
      "name": "CLEANING - VACS ROBOTIC ACCESSORIES",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 961,
      "name": "XBOX 360 - HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 962,
      "name": "THUMBSTICKS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 963,
      "name": "GAMES BACKPACKS",
      "Timestamp": "2020-01-08T07:01:40.78+11:00"
    },
    {
      "id": 964,
      "name": "XBOX 360 GAMES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 965,
      "name": "GAMES - TRADE 1 FREE DEAL",
      "Timestamp": "2019-05-15T17:49:56.3600793+00:00"
    },
    {
      "id": 966,
      "name": "XBX GAMES - SOFTWARE",
      "Timestamp": "2020-09-22T09:03:39.66+10:00"
    },
    {
      "id": 967,
      "name": "PS3 GAMES - HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 968,
      "name": "PS3 GAMES - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 969,
      "name": "RETRO CONSOLES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 970,
      "name": "PS3 GAMES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 971,
      "name": "XBOX SERIES ACCESSORIES",
      "Timestamp": "2020-09-14T09:03:38.5+10:00"
    },
    {
      "id": 972,
      "name": "GAMING MOUSE MATS",
      "Timestamp": "2019-07-17T14:42:20.3008662+00:00"
    },
    {
      "id": 973,
      "name": "GAMING SPEAKERS",
      "Timestamp": "2019-05-15T17:49:56.3600793+00:00"
    },
    {
      "id": 974,
      "name": "XBOX ONE CONTROLLERS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 975,
      "name": "GAMES DIGITAL CARDS",
      "Timestamp": "2020-01-09T07:01:40.993+11:00"
    },
    {
      "id": 976,
      "name": "GAMES - TOYS TO LIFE",
      "Timestamp": "2018-08-22T14:28:47.4718369+00:00"
    },
    {
      "id": 977,
      "name": "GAMING KEYBOARDS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 978,
      "name": "3DS - GAMES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 979,
      "name": "PS2 GAMES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 980,
      "name": "Wii GAMES - HARDWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 981,
      "name": "Wii GAMES - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 982,
      "name": "XBONE- SPORT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 983,
      "name": "XBONE - DRIVING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 984,
      "name": "XBONE - SHOOTER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 985,
      "name": "Wii GAMES - SOFTWARE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 986,
      "name": "XBONE - FAMILY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 987,
      "name": "STREAMING",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 988,
      "name": "PS5 SOFTWARE",
      "Timestamp": "2020-07-20T15:54:56.71+10:00"
    },
    {
      "id": 989,
      "name": "XBOX LIVE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 990,
      "name": "GAMES RACING",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 991,
      "name": "PSN CARDS",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 992,
      "name": "3DS - ACCESSORIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 993,
      "name": "GAMES - SKYLANDERS STARTER PACKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 994,
      "name": "PC 2 FOR $20",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 995,
      "name": "WiiU - SPORT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 996,
      "name": "STRATEGY GUIDES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 997,
      "name": "WiiU - FAMILY FUN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 998,
      "name": "WiiU - DRIVING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 999,
      "name": "GAMES - OLD TRADE IN",
      "Timestamp": "2018-07-11T03:05:28.8764397+00:00"
    },
    {
      "id": 1000,
      "name": "VOUCHERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1001,
      "name": "PUNK / EMO / HARDCORE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1002,
      "name": "ALTERNATIVE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1003,
      "name": "BLUES / GOSPEL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1004,
      "name": "CELTIC / ENGLISH FOLK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1005,
      "name": "VINYL CLEARANCE",
      "Timestamp": "2021-08-20T17:32:09.047+10:00"
    },
    {
      "id": 1006,
      "name": "CHILDRENS (CD)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1007,
      "name": "CLASSICAL (CD)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1008,
      "name": "COMEDY (CD)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1009,
      "name": "COUNTRY / AMERICAN FOLK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1010,
      "name": "DANCE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1011,
      "name": "HIP-HOP / RNB",
      "Timestamp": "2020-06-11T15:54:57.783+10:00"
    },
    {
      "id": 1012,
      "name": "AUSSIE HIP HOP",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1013,
      "name": "VINYL 2 FOR $50 PROMO",
      "Timestamp": "2018-07-23T04:10:35.8986219+00:00"
    },
    {
      "id": 1014,
      "name": "HEAVY METAL / HARD ROCK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1015,
      "name": "JAZZ",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1016,
      "name": "KARAOKE (CD)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1017,
      "name": "BLURAY AUDIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1018,
      "name": "MIND BODY & SOUL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1019,
      "name": "AUDIOBOOK SALE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1020,
      "name": "POPULAR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1021,
      "name": "MUSIC MERCH",
      "Timestamp": "2019-05-15T17:49:56.3600793+00:00"
    },
    {
      "id": 1022,
      "name": "REGGAE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1023,
      "name": "SINGLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1024,
      "name": "CHRISTMAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1025,
      "name": "OST / MUSICAL / SOUND EFX",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1026,
      "name": "VARIOUS / COMPILATIONS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1027,
      "name": "WORLD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1028,
      "name": "50s & 60s",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1029,
      "name": "CD OPEN KEY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1030,
      "name": "DVD AUDIO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1031,
      "name": "SACD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1032,
      "name": "VINYL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1033,
      "name": "MUSIC B2G1F",
      "Timestamp": "2022-03-07T12:50:12.213+11:00"
    },
    {
      "id": 1034,
      "name": "Undefined",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1035,
      "name": "VINYL ACCESSORIES",
      "Timestamp": "2018-07-09T01:05:28.9850407+00:00"
    },
    {
      "id": 1036,
      "name": "MUSHROOM 20% OFF",
      "Timestamp": "2021-01-28T11:36:06.813+11:00"
    },
    {
      "id": 1037,
      "name": "CD CLEARANCE",
      "Timestamp": "2022-05-05T12:50:12.237+10:00"
    },
    {
      "id": 1038,
      "name": "Splendid Sounds (Stock)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1039,
      "name": "VINYL PRE ORDER",
      "Timestamp": "2021-11-12T16:30:34.213+11:00"
    },
    {
      "id": 1040,
      "name": "T-Shirts (Music)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1041,
      "name": "EASY LISTENING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1042,
      "name": "FUNK / SOUL",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1044,
      "name": "K-POP",
      "Timestamp": "2020-07-23T15:54:57.94+10:00"
    },
    {
      "id": 1045,
      "name": "SCREAMING JETS PROMO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1050,
      "name": "KARAOKE (DVD)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1051,
      "name": "MUSIC DVD - Alternative / Heavy Metal",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1052,
      "name": "MUSIC DVD - Popular",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1053,
      "name": "MUSIC DVD - Urban Grooves",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1054,
      "name": "MUSIC DVD - Roots / World",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1055,
      "name": "MUSIC DVD - Jazz",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1056,
      "name": "MUSIC DVD - Classical",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1057,
      "name": "MUSIC DVD - Dance",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1058,
      "name": "MUSIC DVD - Musicals / Stageshows",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1059,
      "name": "MUSIC DVD - 50s/60s / Easy Listening",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1060,
      "name": "MUSIC DVD - Blu-Ray",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1061,
      "name": "MUSIC DVD - Christmas",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1062,
      "name": "MUSIC BOOKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1086,
      "name": "FANS - AIR PURIFIER ACCESSORIES",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1087,
      "name": "GAMING CHAIRS",
      "Timestamp": "2018-06-11T23:21:44.3063821+00:00"
    },
    {
      "id": 1088,
      "name": "MRA SEPT SALE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1089,
      "name": "GAMES - TRADE IN DEAL INCLUSIONS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1090,
      "name": "GAMES CLEARANCE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1091,
      "name": "GAMING CHAIRS - LARGE",
      "Timestamp": "2019-05-15T17:49:56.3600793+00:00"
    },
    {
      "id": 1101,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1102,
      "name": "DOCUMENTARY (FILM)",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1103,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2021-03-15T22:10:26.903+11:00"
    },
    {
      "id": 1104,
      "name": "KIDS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1105,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2021-03-15T22:10:26.903+11:00"
    },
    {
      "id": 1106,
      "name": "COMEDY (DVD)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1107,
      "name": "DRAMA",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1108,
      "name": "HD DVD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1109,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2021-03-15T22:10:26.903+11:00"
    },
    {
      "id": 1110,
      "name": "BLU RAY & 4K BUY 1 GET 1 FREE",
      "Timestamp": "2022-05-04T12:50:12.383+10:00"
    },
    {
      "id": 1111,
      "name": "EVERY SINGLE TV SHOW B2G1F",
      "Timestamp": "2022-05-23T12:50:12.22+10:00"
    },
    {
      "id": 1112,
      "name": "DVD OPEN KEY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1113,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-01-13T02:16:09.51+11:00"
    },
    {
      "id": 1114,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-01-13T02:16:09.51+11:00"
    },
    {
      "id": 1115,
      "name": "FITNESS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1116,
      "name": "TV ANIME",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1117,
      "name": "WORLD CINEMA",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1118,
      "name": "VIDEO MOVIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1119,
      "name": "SPORT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1120,
      "name": "COMEDY - STAND UP",
      "Timestamp": "2022-01-12T02:16:09.753+11:00"
    },
    {
      "id": 1121,
      "name": "GAMES - TRADE IN DEAL EXCLUSIONS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1122,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1123,
      "name": "BLU RAY 2 FOR $20",
      "Timestamp": "2022-05-23T12:50:12.22+10:00"
    },
    {
      "id": 1124,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-06-02T12:50:12.35+10:00"
    },
    {
      "id": 1125,
      "name": "SUPERHEROES",
      "Timestamp": "2018-03-16T04:00:51.3742249+00:00"
    },
    {
      "id": 1126,
      "name": "4K 2 FOR $40",
      "Timestamp": "2022-06-02T12:50:12.35+10:00"
    },
    {
      "id": 1127,
      "name": "DISNEY $12.98 DVD PROMO",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1128,
      "name": "ANIME - FILM",
      "Timestamp": "2018-06-13T03:21:44.27788+00:00"
    },
    {
      "id": 1129,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1130,
      "name": "UNISPHE 3 FOR $30 MOVIES",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1131,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-01-13T02:16:09.51+11:00"
    },
    {
      "id": 1132,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1133,
      "name": "TV BBC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1134,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1135,
      "name": "BOX SETS - MOVIES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1136,
      "name": "CLASSICS",
      "Timestamp": "2018-04-09T06:00:51.0916861+00:00"
    },
    {
      "id": 1137,
      "name": "TV SCI FI",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1138,
      "name": "TV DRAMA",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1139,
      "name": "TV ABC",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1140,
      "name": "PC - ACTION / ADVENTURE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1141,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-01-14T02:16:09.733+11:00"
    },
    {
      "id": 1142,
      "name": "MERCH MUGS",
      "Timestamp": "2020-07-30T15:54:57.58+10:00"
    },
    {
      "id": 1143,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2021-07-20T15:04:44.67+10:00"
    },
    {
      "id": 1144,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1145,
      "name": "BOX SETS - TV SHOWS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1146,
      "name": "KIDS - TV SHOWS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1147,
      "name": "TV HBO",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1148,
      "name": "MERCH FIGPINS",
      "Timestamp": "2021-05-31T13:49:02.757+10:00"
    },
    {
      "id": 1149,
      "name": "PC  - SPORT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1150,
      "name": "PC - WORLD OF WARCRAFT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1151,
      "name": "GAMES - $19 TITLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1152,
      "name": "PC - STRATEGY / ROLEPLAY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1153,
      "name": "PC - FAMILY FUN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1154,
      "name": "SPARE DVD PRODUCT GROUP",
      "Timestamp": "2022-01-13T02:16:09.51+11:00"
    },
    {
      "id": 1155,
      "name": "XBOX SERIES CONTROLLERS",
      "Timestamp": "2020-09-14T09:03:38.5+10:00"
    },
    {
      "id": 1156,
      "name": "TV ANIME - BLU RAY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1157,
      "name": "PC - SIMS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1158,
      "name": "TV COMEDY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1159,
      "name": "MERCH POP! VINYL",
      "Timestamp": "2021-01-21T11:36:06.6+11:00"
    },
    {
      "id": 1160,
      "name": "BLU RAY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1161,
      "name": "BLU RAY BOX SETS - MOVIES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1162,
      "name": "TV SHOWS - BLU RAY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1163,
      "name": "SPECIAL INTEREST",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1164,
      "name": "MERCH CALENDAR",
      "Timestamp": "2020-10-05T09:03:38.66+11:00"
    },
    {
      "id": 1165,
      "name": "TV CARTOON",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1166,
      "name": "TV CRIME A-Z",
      "Timestamp": "2018-04-23T02:28:59.9676538+00:00"
    },
    {
      "id": 1167,
      "name": "PC - FIRST PERSON SHOOTER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1168,
      "name": "PC - RACING / DRIVING",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1169,
      "name": "DVD PROMO VOUCHERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1170,
      "name": "MERCH JIGSAW BUY 1 GET 1 FREE",
      "Timestamp": "2022-06-09T12:50:12.597+10:00"
    },
    {
      "id": 1171,
      "name": "CALL OF DUTY BLACK OPS 2",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1172,
      "name": "TV HBO - BLU RAY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1173,
      "name": "TV REALITY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1174,
      "name": "TV DOCUMENTARY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1175,
      "name": "MULTI PACKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1176,
      "name": "MERCH CARD & BOARD GAMES",
      "Timestamp": "2020-09-04T09:03:38.903+10:00"
    },
    {
      "id": 1177,
      "name": "MOVIE & TV SHOW CLEARANCE",
      "Timestamp": "2022-01-11T02:16:09.727+11:00"
    },
    {
      "id": 1178,
      "name": "MERCH ACTION FIGURES",
      "Timestamp": "2021-12-17T02:16:09.88+11:00"
    },
    {
      "id": 1179,
      "name": "MERCH JIGSAW",
      "Timestamp": "2020-10-05T09:03:38.66+11:00"
    },
    {
      "id": 1180,
      "name": "A-Z MOVIES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1181,
      "name": "KIDS - DISNEY BAY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1182,
      "name": "BLU RAY - ACTIVE 3D",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1183,
      "name": "MERCH COLLECTIBLES",
      "Timestamp": "2020-09-04T09:03:38.903+10:00"
    },
    {
      "id": 1184,
      "name": "HORROR A-Z",
      "Timestamp": "2018-04-23T02:28:59.9676538+00:00"
    },
    {
      "id": 1185,
      "name": "TV BBC - BOX SETS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1186,
      "name": "MERCH TRADING CARDS",
      "Timestamp": "2021-05-12T13:49:03.053+10:00"
    },
    {
      "id": 1187,
      "name": "BLU RAY BOX SETS - TV SHOWS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1188,
      "name": "MERCH APPAREL",
      "Timestamp": "2020-10-09T15:47:13.813+11:00"
    },
    {
      "id": 1189,
      "name": "MERCH APPAREL CLEARANCE",
      "Timestamp": "2022-06-07T12:50:12.403+10:00"
    },
    {
      "id": 1190,
      "name": "DVD INTERACTIVE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1191,
      "name": "MERCH POP! VINYL B2G1F",
      "Timestamp": "2021-05-26T13:49:02.75+10:00"
    },
    {
      "id": 1192,
      "name": "BOXSET BLITZ PROMO",
      "Timestamp": "2022-04-20T12:50:12.047+10:00"
    },
    {
      "id": 1193,
      "name": "KIDS - BLU RAY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1194,
      "name": "MERCH STATIONERY",
      "Timestamp": "2020-10-05T09:03:38.66+11:00"
    },
    {
      "id": 1195,
      "name": "ROADSHOW GET HOOKED PROMOTION",
      "Timestamp": "2021-04-13T22:10:26.92+10:00"
    },
    {
      "id": 1196,
      "name": "MERCH 2 FOR $20 POSTERS",
      "Timestamp": "2021-04-08T22:10:26.913+10:00"
    },
    {
      "id": 1197,
      "name": "4K ULTRA HD",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1198,
      "name": "TV ABC - BLU RAY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1199,
      "name": "TV BBC - BLU RAY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1201,
      "name": "GIFT VOUCHERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1202,
      "name": "INSTALLATIONS - AV",
      "Timestamp": "2020-10-27T21:03:20.583+11:00"
    },
    {
      "id": 1203,
      "name": "JB NOW CARDS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1204,
      "name": "CUSTOMER REPAIRS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1205,
      "name": "SAMPLES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1206,
      "name": "DEPOSITS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1207,
      "name": "EXTENDED WARRANTY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1208,
      "name": "EXTENDED WARRANTY - REPLACEMENT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1209,
      "name": "SECOND HAND STOCK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1210,
      "name": "FINANCE SKUs",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1211,
      "name": "RINGTONES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1212,
      "name": "Merchant Service Charges",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1213,
      "name": "SMALLS MISCELLANEOUS",
      "Timestamp": "2022-04-29T12:50:12.43+10:00"
    },
    {
      "id": 1214,
      "name": "APPLE EXT WARRANTY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1215,
      "name": "AIR CON INSTLL (COSTED)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1216,
      "name": "AIR CON INSTALL WARRANTY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1217,
      "name": "Charity Items",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1218,
      "name": "JB BAGS",
      "Timestamp": "2020-02-03T07:01:41.133+11:00"
    },
    {
      "id": 1219,
      "name": "APPLE WARRANTY (BOXED STOCK)",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1220,
      "name": "GIFT VOUCHER TINS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1221,
      "name": "OPT IN APPLE EXT WARRANTY",
      "Timestamp": "2021-09-06T17:32:08.86+10:00"
    },
    {
      "id": 1222,
      "name": "HOME DELIVERY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1223,
      "name": "DeviceEnsure",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1224,
      "name": "COMMERCIAL EXTENDED WARRANTY",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1225,
      "name": "Mobile Extras - Subscription",
      "Timestamp": "2021-03-16T22:10:26.733+11:00"
    },
    {
      "id": 1226,
      "name": "Mobile Extras - Upfront",
      "Timestamp": "2021-03-16T22:10:26.733+11:00"
    },
    {
      "id": 1227,
      "name": "INSTALLATIONS - DELIVERY",
      "Timestamp": "2021-06-29T15:04:44.14+10:00"
    },
    {
      "id": 1228,
      "name": "INSTALLATIONS - TRAVEL",
      "Timestamp": "2021-07-07T15:04:44.4+10:00"
    },
    {
      "id": 1229,
      "name": "PRE-ORDER ANDROID MOBILE EXTRAS",
      "Timestamp": "2021-08-12T15:04:44.65+10:00"
    },
    {
      "id": 1230,
      "name": "INSTALLATIONS - TECH",
      "Timestamp": "2020-10-27T21:03:20.583+11:00"
    },
    {
      "id": 1231,
      "name": "BUY BACK",
      "Timestamp": "2022-05-23T12:50:12.22+10:00"
    },
    {
      "id": 1232,
      "name": "PRE-ORDER APPLE MOBILE EXTRAS",
      "Timestamp": "2021-09-08T17:32:08.817+10:00"
    },
    {
      "id": 1233,
      "name": "EXTRA CARE",
      "Timestamp": "2022-01-17T02:16:09.61+11:00"
    },
    {
      "id": 1248,
      "name": "TECH ON WHEELS - RIDEABLES BULKY",
      "Timestamp": "2020-06-30T15:54:57.93+10:00"
    },
    {
      "id": 1249,
      "name": "TECH ON WHEELS - ACCESSORIES",
      "Timestamp": "2020-06-30T15:54:57.93+10:00"
    },
    {
      "id": 1250,
      "name": "COMMERCIAL ONLY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1251,
      "name": "COMMERCIAL PANELS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1252,
      "name": "BYOD INSURANCE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 1301,
      "name": "ONSITE INSTALLATIONS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1302,
      "name": "CONTRACT INSTALLATIONS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1303,
      "name": "MEDAL OF HONOR WARFIGHTER",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1400,
      "name": "AUDIO BOOKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1401,
      "name": "BIOGRAPHY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1402,
      "name": "BUSINESS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1403,
      "name": "CLASSIC FICTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1404,
      "name": "COLOUR & ACTIVITY BOOKS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1405,
      "name": "COMPUTING & IT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1406,
      "name": "CRAFTS & HOBBIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1407,
      "name": "CRIME FICTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1408,
      "name": "EROTIC FICTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1409,
      "name": "FANTASY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1410,
      "name": "FICTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1411,
      "name": "FOOD & DRINK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1412,
      "name": "HEALTH & LIFESTYLE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1413,
      "name": "HOME & GARDEN",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1414,
      "name": "HUMOUR",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1415,
      "name": "MUSIC/FILM/TV/PERFORMING ARTS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1416,
      "name": "PICTURE BOOK",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1417,
      "name": "ROMANCE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1418,
      "name": "SCIENCE FICTION",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1419,
      "name": "SPORT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1420,
      "name": "THRILLER & SUSPENSE",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1421,
      "name": "TRUE CRIME & CRIMINOLOGY",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1422,
      "name": "YOUNG ADULT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 1502,
      "name": "EDUCATION INSTALLATIONS",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 2000,
      "name": "BOOKS - IT",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2001,
      "name": "BOOKS - COMPUTERS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2002,
      "name": "BOOKS - MOBILE PHONES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2003,
      "name": "BOOKS - DIGITAL CAMERAS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2004,
      "name": "BOOKS - MUSICAL INSTRUMENTS",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2005,
      "name": "BOOKS - MUSIC BIOG",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2006,
      "name": "BOOKS - MOVIES",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 2014,
      "name": "GAMES - STARLINK",
      "Timestamp": "2018-08-22T14:28:47.4718369+00:00"
    },
    {
      "id": 2015,
      "name": "TRADE IN CONSOLES",
      "Timestamp": "2018-05-02T02:28:59.9490902+00:00"
    },
    {
      "id": 3001,
      "name": "PROJECT",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 3002,
      "name": "MANAGED SERVICES",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 3003,
      "name": "REMOTE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 3004,
      "name": "ONSITE",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 3005,
      "name": "IMAGING BYOD",
      "Timestamp": "2017-12-01T02:26:03.5469301+00:00"
    },
    {
      "id": 9999,
      "name": "MGM DVD",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    },
    {
      "id": 99999,
      "name": "Do not use - For Processing",
      "Timestamp": "2017-12-01T02:26:03.5459369+00:00"
    }
  ]

  export const seasons = [
    {
      "id": "CHART- INE",
      "name": "INERTIA CHART TITLES"
    },
    {
      "id": "MW",
      "name": "Managed Warehouse"
    },
    {
      "id": "Z",
      "name": "ONLINE ONLY PRODUCT"
    },
    {
      "id": "COMQ",
      "name": "COMMERCIAL EXCLUSIVE PRODUCTS - QUIT"
    },
    {
      "id": "MW+",
      "name": "Managed Warehouse Event"
    },
    {
      "id": "AW",
      "name": "A Range Warehouse"
    },
    {
      "id": "QT2",
      "name": "for all Quatius T2 stock"
    },
    {
      "id": "Z+",
      "name": "ONLINE + SELECTED STORES"
    },
    {
      "id": "BYOD",
      "name": "FOR BYOD PORTAL - EDUCATION"
    },
    {
      "id": "EDU",
      "name": "Education Transaction Only"
    },
    {
      "id": "COMW",
      "name": "Commercial Only Bulky Products"
    },
    {
      "id": "F",
      "name": "TEST"
    },
    {
      "id": "NRV",
      "name": "Music NRV Clearance. No Orders or C/O's!"
    },
    {
      "id": "DEMO",
      "name": "Demo models only"
    },
    {
      "id": "CL",
      "name": "Music Clearance"
    },
    {
      "id": "E",
      "name": "CD / DVD Essential range must be stocked"
    },
    {
      "id": "A",
      "name": "Hardware stock ranged in all stores"
    },
    {
      "id": "B",
      "name": "Hardware Option stock"
    },
    {
      "id": "C",
      "name": "Hardware ranged with approval of PM"
    },
    {
      "id": "D",
      "name": "Deleted range not to be reordered"
    },
    {
      "id": "Q",
      "name": "Quit stock to cleared"
    },
    {
      "id": "M",
      "name": "Hardware Managed model stock"
    },
    {
      "id": "X",
      "name": "Not to sold or ordered"
    },
    {
      "id": "Comp",
      "name": "Computer stock - Preston Only"
    },
    {
      "id": "O",
      "name": "CD / DVD Optional Range"
    },
    {
      "id": "Chart",
      "name": "CD / DVD Chart"
    },
    {
      "id": "CD/DVD Cat",
      "name": "CD / DVD Catalogue Product"
    },
    {
      "id": "Camera",
      "name": "Full Camera Stores Only"
    },
    {
      "id": "G",
      "name": "Software Group Orders"
    },
    {
      "id": "S",
      "name": "CD / DVD SPECIALIST RANGE / CUST ORDER"
    },
    {
      "id": "U",
      "name": "VINYL INDIE Essential Range"
    },
    {
      "id": "T1",
      "name": "Tier 1"
    },
    {
      "id": "T2",
      "name": "Tier 2"
    },
    {
      "id": "T3",
      "name": "Tier 3"
    },
    {
      "id": "GH",
      "name": "Games Hardware"
    },
    {
      "id": "T4",
      "name": "Tier 4"
    },
    {
      "id": "M+",
      "name": "Managed Stock, Product Managers Only"
    },
    {
      "id": "SW",
      "name": "Steering Wheels games"
    },
    {
      "id": "EL",
      "name": "End of Life"
    },
    {
      "id": "SBS",
      "name": "DVD SBS TITLES"
    },
    {
      "id": "T",
      "name": "Games trade in"
    },
    {
      "id": "CHART - HO",
      "name": "CD / DVD Chart Head office orders"
    },
    {
      "id": "CTO",
      "name": "Apple custom builds"
    },
    {
      "id": "COM",
      "name": "COMMERCIAL EXCLUSIVE PRODUCT"
    },
    {
      "id": "P",
      "name": "PRO FORMA (CA)"
    },
    {
      "id": "FIRM SALE",
      "name": "Firm sale product - cannot be returned"
    },
    {
      "id": "S1",
      "name": "Pending S Range titles"
    },
    {
      "id": "TT",
      "name": "Games - Trestle table stock"
    },
    {
      "id": "BTO",
      "name": "DELL CUSTOM BUILD MODELS"
    },
    {
      "id": "NR",
      "name": "DVD NEW RELEASE"
    },
    {
      "id": "CAT",
      "name": "DVD CATALOGUE"
    },
    {
      "id": "SDVD",
      "name": "Music DVD S Range"
    },
    {
      "id": "W",
      "name": "ONLINE ONLY PRODUCT"
    },
    {
      "id": "MISC",
      "name": "MISC & OPEN SKUS"
    },
    {
      "id": "MIC",
      "name": "MUSICAL INSTRUMENTS (COM)"
    },
    {
      "id": "MICQ",
      "name": "MUSICAL INSTRUMENTS QUIT STOCK"
    }
   ]